var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7292 3.29576C14.0268 2.99933 14.0268 2.51874 13.7292 2.22232C13.4317 1.92589 12.9493 1.92589 12.6517 2.22232L10.6041 4.25846C10.3066 4.55488 10.3066 5.03548 10.6041 5.3319C10.9017 5.62832 11.3841 5.62832 11.6816 5.3319L13.7292 3.29576Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04763 5.80722C5.04763 5.24828 5.50245 4.79517 6.0635 4.79517C6.62455 4.79517 7.07938 5.24828 7.07938 5.80722V7.83131H7.20064C7.50925 7.83131 7.80112 7.97107 7.99391 8.21114L9.51747 10.1084H2.60953L4.1331 8.21114C4.32588 7.97107 4.61775 7.83131 4.92636 7.83131H5.04763V5.80722Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.127 11.6265V19.9759C10.127 21.0938 9.21734 22 8.09524 22H4.03175C2.90964 22 2 21.0938 2 19.9759V11.6265H10.127Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7292 10.4042C14.0268 10.1078 14.0268 9.62718 13.7292 9.33076L11.6816 7.29461C11.3841 6.99819 10.9017 6.99819 10.6041 7.29461C10.3066 7.59104 10.3066 8.07163 10.6041 8.36805L12.6517 10.4042C12.9493 10.7006 13.4317 10.7006 13.7292 10.4042Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1746 5.55423C12.7538 5.55423 12.4127 5.89406 12.4127 6.31326C12.4127 6.73247 12.7538 7.0723 13.1746 7.0723H17.2381C17.6589 7.0723 18 6.73247 18 6.31326C18 5.89406 17.6589 5.55423 17.2381 5.55423H13.1746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpray);
export default __webpack_public_path__ + "static/media/spray.1b6f54b85023960c22f7f9a7aedf535e.svg";
export { ForwardRef as ReactComponent };